import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../../contexts/Language';
import { ErrorMessage } from '../Validator';


const AuthenticatorForm = props => {
  const { onChange, formData, onLogin, authenticatorData } = props;
  const [validation, setValidation] = useState(null);

  return (
    <div className="account-card-content">
      {
        validation && (
          <ErrorMessage Validation={validation} />
        )
      }
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <form
        className="form-horizontal m-t-30"
        name="loginForm"
        onSubmit={async e => {
          e.preventDefault();
          const response = await onLogin(formData);
          if (!response) {
            setValidation({
              error: true,
              message: 'Invalid authenticator code',
            });
          }
        }}
      >
        <div className="form-group row" style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>
          <mark style={{ textAlign: 'center' }}>Please enter an authenticator code using one of the following apps</mark>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>
            <a target="_blank" href="https://www.microsoft.com/en-us/security/mobile-authenticator-app" rel="noopener noreferrer" title="microsoft-authenticator" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '2px', padding: '4px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1)' }}>
              <img src="assets/images/microsoft-authenticator.svg" height="50" alt="microsoft-authenticator" />
              <b style={{ fontSize: '10px' }}>Microsoft Authenticator</b>
            </a>
            <a target="_blank" href="https://www.google.com/search?q=google+authenticator" rel="noopener noreferrer" title="google-authenticator" className="m-l-10" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '2px', padding: '4px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1)' }}>
              <img src="assets/images/google-authenticator.svg" height="50" alt="google-authenticator" />
              <b style={{ fontSize: '10px' }}>Google Authenticator</b>
            </a>
          </div>
          <mark style={{ textAlign: 'center' }}>Then, scan the QR code here</mark>
          <img src={authenticatorData.QrImageUrl} alt="Qr Code" height={120} />
          <mark style={{ textAlign: 'center' }}>Or use the secret key</mark>
          <b style={{ textDecoration: 'underline' }}>{authenticatorData.AuthenticatorKey}</b>
        </div>
        <div className="form-group m-t-20">
          <label htmlFor="AuthenticatorCode">{Translate('Authenticator Code')}</label>
          <input type="text" className="form-control" id="AuthenticatorCode" name="AuthenticatorCode" placeholder={Translate('Authenticator Code')} onChange={e => onChange(e)} required />
        </div>
        <div className="form-group row m-t-20">
          <div className="col-sm-12 text-center">
            <button type="submit" className="btn btn-info w-md waves-effect waves-light">{Translate('Log In')}</button>
          </div>
        </div>
      </form>
    </div>
  );
};

AuthenticatorForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
  authenticatorData: PropTypes.object.isRequired,
};

export default AuthenticatorForm;
